import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { NavLink } from 'react-router-dom';

export const ContactSupport = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 24px 0;
`;

export const InfoIcon = styled(Icon)`
    fill: ${Variables.Colors.nx24};
`;

export const Blurb = styled.div`
    padding-left: 8px;
    letter-spacing: 0.2px;
    line-height: 1.36;
    color: ${Variables.Colors.n50};
`;

export const Link = styled(NavLink)`
    color: ${Variables.Colors.b300};
`;
